import { ReactElement } from "react";

export const InformationIcon = (color?: string): ReactElement => {
  const className = 'icon icon--information-icon'
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M7.58333 9.33333H7V7H6.41667M7 4.66667H7.00583M12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.1005 12.25 1.75 9.89949 1.75 7C1.75 4.1005 4.1005 1.75 7 1.75C9.89949 1.75 12.25 4.1005 12.25 7Z"
        stroke={color ? color : '#303E47'}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
